export const countryPrefix = [
  { language: "RO", prefix: "+40" },
  { language: "MD", prefix: "+373" },
  { language: "HU", prefix: "+36" },
  // { language: "PL", prefix: "+48" },
];
